// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"49":"consumption","122":"bim","179":"main","312":"blank"}[chunkId] + "." + {"49":"11abfa42","122":"46b12a02","179":"872b57f9","312":"edfb9082"}[chunkId] + ".css";
};